<template>
	<validationProvider rules="max:30" v-slot="{ errors, valid }" immediate name="在籍学校">
		<p>
			<FormTitleText titleText="在籍学校" />
			<FormAttentionText attentionText="※30字まで" />
		</p>
		<v-text-field
			label=""
			v-model="inputedSchool"
			outlined
			background-color="white"
			hide-details
			:success="valid"
		></v-text-field>
		<FormErrorText :errorText="errors[0]" />
	</validationProvider>
</template>

<script>
import FormTitleText from '../Atoms/FormTitleText'
import FormErrorText from '../Atoms/FormErrorText'
import FormAttentionText from '../Atoms/FormAttentionText'

export default {
	name: 'SchoolForm',
	data: () => ({}),
	props: ['value'],
	mounted() {},
	computed: {
		inputedSchool: {
			get() {
				return this.value
			},
			set(value) {
				this.$emit('input', value)
			}
		}
	},
	methods: {},
	components: {
		FormTitleText,
		FormErrorText,
		FormAttentionText
	}
}
</script>

<style lang="scss" scoped></style>
